<template>
  <!-- <LoadingComponent /> -->

  <Toast position="top-center" />

  <InstallPromptComponent v-if="!isAndroidApp" />

  <OfflineModeComponent v-if="systemStore.maintenanceMode" />
  
  <div class="app-background w-full">
    <!-- Private Layout for authenticated users -->

    <div
      v-if="authStore.isLoggedIn && $route.meta.requiresAuth"
      id="private"
      class="private-layout"
    >
      <TopBarComponent />
      <GlobalLoading />
      <TenantOwnerNoticeComponent />
      <main class="private-main relative">
        <RouterView name="private" />
      </main>
    </div>

    <!-- Public Layout for both authenticated and non-authenticated users -->
    <div
      v-else
      id="public"
      class="app-container container-small flex flex-col w-full"
    >     
      <div class="relative w-full p-4 lg:p-5">      
        <!-- <LanguageSwitcherComponent class="absolute right-0" /> -->
        <LecLogo
          :shrink-img="true"
        />
      </div>
      <div class="order-1 xl:order-2 flex-grow flex w-full relative">
        <!-- router-view-padding2 -->
        <RouterView
          class="router-view-padding px-3 pb-4 w-full pt-0  w-full"
          name="public"
        />
        <GlobalLoading />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted} from 'vue';
import TopBarComponent from '@/components/header/TopBarComponent.vue';
import LecLogo from '@/components/header/LecLogo.vue';
//import LoadingComponent from '@/components/shared/LoadingComponent.vue';
import { useLoadingStore } from '@/stores/useLoadingStore';
import { useAuthStore } from '@/stores/authStore';
import InstallPromptComponent from '@/components/shared/InstallPromptComponent.vue';
import GlobalLoading from '@/components/shared/GlobalLoadingComponent.vue';
import { Capacitor } from '@capacitor/core';
//import { StatusBar, Style } from '@capacitor/status-bar';
import { useSystemStore } from '@/stores/systemStore';
import OfflineModeComponent from '@/components/shared/OfflineComponent.vue';
import { useMessaging } from '@/composables/useMessaging';
import Toast from 'primevue/toast';
import TenantOwnerNoticeComponent from '@/components/shared/TenantOwnerNoticeComponent.vue';


export default defineComponent({
  components: {
    TopBarComponent,
    LecLogo,
    InstallPromptComponent,
    GlobalLoading,
    OfflineModeComponent,
    Toast,
    TenantOwnerNoticeComponent,
  },
  setup() {
    const loadingStore = useLoadingStore();
    const authStore = useAuthStore();
    const { registerHandlers } = useMessaging();
    const isAndroidApp = Capacitor.getPlatform() === 'android';
    const isNativeApp = Capacitor.isNativePlatform()
    const isIosApp = Capacitor.getPlatform() === 'ios'
    const systemStore = useSystemStore();
    

    onMounted(async () => {      
      
      // if (isNativeApp) {
      //   if (isIosApp) {
      //     //await StatusBar.setStyle({ style: Style.Light });
      //     //await StatusBar.setBackgroundColor({ color: '#000000' });
      //   } else if (isAndroidApp) {
      //     //await StatusBar.setBackgroundColor({ color: '#000000' });
      //    // await StatusBar.setStyle({ style: Style.Dark });
      //   }
      // }

      await authStore.fetchUserIfNeeded();
      const loadingItem = loadingStore.addToLoadingStack('simulated-loading');
      setTimeout(() => {    
        loadingStore.removeFromLoadingStack(loadingItem);
      }, 0);

      if (authStore.user) {
        await registerHandlers(authStore.user);
      }
    });


    return {
      authStore, 
      isNativeApp,
      isAndroidApp,
      systemStore,
      isIosApp,
    };
  },
});
</script>

<style lang="scss">
html, body {
  font-family: var(--base-font);
}

.p-divider-horizontal {
  margin-top: 24px !important;
  margin-bottom: 24px !important;
}

.app-background {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100dvh;
  padding: 0;

  &.keyboard-is-open {
    overflow: auto;
  }

  @media (min-width: 1399.98px) {
    padding: 1rem;
  }
}

/* Private layout: full width, no container, no outer padding */
.app-background:has(#private) {
  padding: 0 !important;
  align-items: stretch;
}

.private-layout {
  display: flex;
  flex-direction: column;
  min-height: 100dvh;
  width: 100%;
  background-color: #f6f8fa;
}

.private-main {
  flex: 1;
  width: 100%;
  overflow-y: auto;

  > * {
    max-width: 1180px;
    width: 100%;
    margin-left: auto;
    margin-right: auto;
    padding: 24px;
    box-sizing: border-box;
  }
  @media (max-width: 768px) {
    > * {
      padding: 16px;
    }
  }

  > .device-view-container {
    padding: 0;
    max-width: 100%;
  }

  > .layout-shell {
    padding: 0;
    max-width: 100%;
    margin-left: 0;
    margin-right: 0;
  }

  

  > .system-status-view-container {
    padding: 0;
    max-width: 100%;
    height: 100%;
  }
}

.app {
  background-image: url('@/assets/img/bg.png');
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
}

.app-container {
  background-color: #fff;
  box-shadow: 0px 0px 40px 0px #00000026;
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;

  @media (max-width: 1399.98px) {
    height: 100dvh;
    width: 100%;
    border-radius: 0;
    box-shadow: none;
  }

  @media (min-width: 1399.98px) {
    height: 100%;
  }
}

/* #private handled by .private-layout */

@media (min-width: 1399.98px) {
  .pt-md-3 {
    padding-top: 0 !important;
  }
}

.container-small {
  @media (min-width: 1399.98px) {
    max-width: 768px;
    min-height: 768px;
    height: auto;
  }
}

.container-large {
  @media (min-width: 1399.98px) {
    width: 90vw;
    height: 95vh;
  }
}

.navbar-custome {
  @media (max-width: 1199.98px) {
    width: 100%;
  }
}

.custom-h-100 {
  height: auto;

  @media (min-width: 1199.98px) {
    height: 100%;
  }
}

.maintenance-mode {
  backdrop-filter: blur(4px);
  z-index: 99999;
}
</style>